define('appkit/controller.registry',[
  'underscore',
  'backbone',
  'backbone.radio'
], function(
  _,
  Backbone,
  Radio
) {

  function ControllerRegistry(app, region, channelName) {
    if (!app) {
      throw new Error('You must specify the app');
    }
    this.app = app;
    this.region = region;
    this.channel = Radio.channel(channelName || 'routing');
  };

  ControllerRegistry.extend = Backbone.Model.extend;

  _.extend(ControllerRegistry.prototype, Backbone.Events, {

    setRegion: function(region) {
      this.region = region;
      return this;
    },

    // construct a controller instance from the specified
    // constructor
    buildController: function(Controller, state) {
      return new Controller(this.app, this.region, state);
    },

    // kick off the controller
    startController: function(controller) {
      controller.start();
    },

    // make sure that we have a region
    verifyRegion: function() {
      if (!this.region) {
        throw new Error('You must specify a region');
      }
    },

    // register a controller to the chosen channel
    register: function(name, Controller) {
      this.channel.on(name, function(state) {
        this.verifyRegion();
        var controller = this.buildController(Controller, state);
        try {
          this.trigger('controller:before:start', controller);
          this.startController(controller);
          this.trigger('controller:start', controller);
        } catch (e) {
          state.trigger('error', e);
          this.trigger('controller:error', controller, e);
        }
      }, this);
      return this;
    }

  });

  return ControllerRegistry;
});

